module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABUUlEQVQ4T8WUzVECQRCFXyN31ww2BMxgicDBGs5gBpuBGIGGIOcd3M4AQjAEQsCzwrNmdBFhdl3QKvvc/dXrvyf445AmnjEm7XYxApD5PCH0dY2pqq7q6mqBw2szpuAekBcBlUACSAbwXDroF4U+x6BRoLUmE8ic4J1zOqkKjTFJ9wwPAK7e1rhU1eU+tAY4UJ/oXGliKoZ2sCC5dDMdtwIO7YDY8KZ40scY0FqTg7h1M71oDSTYd04XNcAwksKVBx1GW/YKfw0MW+2EE4FAMoJ+i3XnkQikRzB0IBtMq/FsFQZV5BSCJYlUBAcb3G1/mxNyZVS1/x3YMLemB9gd0f8ArTUTEGns7rzyoxV6oF9U4crw0/txCjAXIi1mmv8J8CeHO1rhqcAVyDkFUVuq9T+iB5F+4crk4yk+w1sWILkE32sfBFYinFT+2OjY7bFfme+d2PAVeAY2CQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lock.png
// module id = eV+J
// module chunks = 3